window.BoostActivity = {
	expanded: false,
	isnew: true,

	init() {
		this.Dom = BoostDom;
		this.Model = BoostModel;
		this.Controller = BoostController;
		this.Storage = BoostStorage;

		this.expanded = !this.Storage.has("hideactivity");

		if ((this.Model.get("state") === "reporting") && !this.expanded) {
			this.expand();
		} else {
			this.Dom.activity.toggleClass("expanded", this.expanded);
		}

		this.listen();
	},

	listen() {
		this.Dom.activity.on("click tap", "#boost_activity_toggler a", ev=> {
			ev.preventDefault();

			// ev.target is what they actually clicked on (which is what we want to know)
			const target = $(ev.target);

			// if a report is up, the toggle button should become a close button
			if (this.Model.get("state") === "reporting") {
				if (target.hasClass("close")) {
					this.Controller.closeReport();
				} else {
					return true;
				}
			}

			this.toggle();
		});

		// prevent overscoll on the display body
		ScrollHelpers.preventOverscroll('event_display_body');

		// show scrollbars when expanded for firefox
		if (this.Dom.body.hasClass("mac") && this.Dom.body.hasClass("firefox")) {
			$("#event_display_body").on("mouseenter", this.ffScrollBars);
		}
	},

	reset() {
		this.isnew = true;
		this.expand();
	},

	toggle() {
		if (this.expanded) {
			this.retract();
		} else {
			this.expand();
		}
	},

	expand() {
		const { sookiename, sookiehash } = Context.get("boostDict");
		this.Dom.activity.removeClass("collapsed flashed").addClass("expanded");
		this.Storage.remove("hideactivity");
		AjaxSookie.update(sookiename, { hideactivity: 0 }, 86400*365, sookiehash, false, true);
		this.clearFlash();
		this.expanded = true;
	},

	retract() {
		const { sookiename, sookiehash } = Context.get("boostDict");
		this.Dom.activity.removeClass("expanded flashed").addClass("collapsed");
		this.Storage.add("hideactivity");
		AjaxSookie.update(sookiename, { hideactivity: 1 }, 86400*365, sookiehash, false, true);
		this.clearFlash();
		this.expanded = false;
	},

	notify() {
		this.Dom.activity.addClass("flashed");

		if (!this.Storage.has("hideactivity") || this.isnew) {
			this.isnew = false;
			this.expand();
		}
	},

	clearFlash() {
		this.Dom.activity.removeClass("flashed");
	},

	ffScrollBars() {
		const event_display_body = $('#sevent_display_body');
		// if the event display is expanded, then show the scrollbar

		if (this.expanded) {
			let scrollBarDelay;
			event_display_body.css("overflowY", 'auto');

			scrollBarDelay = setTimeout(() => {
				event_display_body.css("overflowY", 'scroll');
				clearTimeout(scrollBarDelay);
			}, 10);
		}
	},

	updateActivity(activity) {
		let anyadded;

		for (let person of Array.from(activity)) {
			person.screenname = person.username;

			if (EventUiManager.update(person, { type: person.ietype })) {
				anyadded = true;
			}
		}

		if (anyadded) {
			this.notify();
		}
	},
};



// WEBPACK FOOTER //
// ./src/legacy/boosts/controller_activity.js